import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const NotFound404 = () => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  const message = "Oops! The page you're looking for doesn't exist.";

  useEffect(() => {
    // Fade in the whole container
    gsap.fromTo(
      containerRef.current,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1.2, ease: "power3.out" }
    );

    // Simulate typewriter effect for the message
    let chars = message.split("");
    let currentText = "";
    let i = 0;

    const interval = setInterval(() => {
      if (i < chars.length) {
        currentText += chars[i];
        textRef.current.innerText = currentText;
        i++;
      } else {
        clearInterval(interval);
      }
    }, 40); // speed of typing

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      ref={containerRef}
      className="d-flex flex-column justify-content-center align-items-center py-5 text-center bg-light"
    >
      <h1 className="display-4 fw-bold text-primary">404</h1>
      <p className="lead text-secondary mb-4" ref={textRef}></p>
      <a href="/" className="btn btn-primary px-4 py-2">
        Go Back Home
      </a>
    </div>
  );
};

export default NotFound404;
